// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicPostInfo (params?: {}): Promise<Dict | List | string>;
    privatePostExchange (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
